exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.test {\n  background: rgba(0, 0, 0, 0.418);\n}\n", ""]);

// exports
